export const GET_EVENT_LEVELS_REQUESTED = "GET_EVENT_LEVELS_REQUESTED";
export const GET_EVENT_LEVELS_FULFILLED = "GET_EVENT_LEVELS_FULFILLED";
export const GET_EVENT_LEVELS_REJECTED = "GET_EVENT_LEVELS_REJECTED";
